import '@common/ui/styles.css'
import { UiProvider } from '@common/ui'
import React from 'react'
import { useAuth, withAuthenticationRequired } from 'react-oidc-context'
import { ImpersonationProvider } from './io/context/ImpersonationContext'
import LandingPage from './pages/LandingPage'
import { getBranding } from './ui/theme/branding'
import GlobalLoadingIndicator from './components/feedback/GlobalLoadingIndicator'
import { useLogAuthContext } from './util/Debug'
import { FormErrorProvider } from './util/FormErrorBus'
import ScreenSpanTracker from './otel/ScreenSpanTracker'
import { extractProfileClaims } from './io/api/authorization/profileClaims'
import { CompactNavigationProvider } from './components/layout/CompactNavigationContext'

const App = () => {
  useLogAuthContext()
  const auth = useAuth()

  const { organizationId, userEntityId } = auth.user?.profile
    ? extractProfileClaims(auth.user.profile)
    : { organizationId: undefined, userEntityId: undefined }
  const branding = getBranding(organizationId)

  return (
    <UiProvider clientBrand={branding.clientBrand} logo={<img src={branding.logoSrc} alt={branding.logoAlt} />}>
      <FormErrorProvider>
        <ImpersonationProvider>
          <ScreenSpanTracker organizationId={organizationId} userEntityId={userEntityId} />
          <CompactNavigationProvider>
            <GlobalLoadingIndicator />
            <LandingPage />
          </CompactNavigationProvider>
        </ImpersonationProvider>
      </FormErrorProvider>
    </UiProvider>
  )
}

export default withAuthenticationRequired(App)
